import { Component, Inject, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HOST_NAME } from 'src/app/global.tokens';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { BasePageComponent } from '../../base-page/base-page.component';


@Component({
  selector: 'app-tournament-streaming',
  templateUrl: './tournament-streaming.component.html',
  styleUrls: ['./tournament-streaming.component.scss']
})
export class TournamentStreamingComponent extends BasePageComponent {

  constructor(
    private sanitizer: DomSanitizer,
    @Inject(HOST_NAME) public hostName,
    private detectDeviceService: DetectDeviceService,
  ) { super() }

  @Input() channelName: string;
  safeUrl: SafeResourceUrl;

  document: Document = document;

  ngOnInit(): void {
    this.isDesktop = this.detectDeviceService.isDesktop();

    const twitchStreamUrl = `https://player.twitch.tv/?channel=${this.channelName}&enableExtensions=true&muted=true&parent=${this.hostName}&player=popout&playsinline&quality=auto&volume=0.5`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(twitchStreamUrl);
  }


}
